import { Injectable } from "@angular/core";
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentTemplate } from "../../../models/SCMTemplates";
import { TemplatesService } from "../../../services/templates.service";

@Injectable()
export class ShipmentTemplatesResolver implements Resolve<Array<ShipmentTemplate>> {

    resolve(): Observable<Array<ShipmentTemplate>> {
        return this.templatesService.getShipmentTemplates();
    }

    constructor(private templatesService: TemplatesService) { }
}